import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ExclamationIcon, CheckCircleIcon } from '@heroicons/vue/solid';

import { MetaConnectionStatusResult } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppAssetStatusPanel',
  props: {
    connection: { type: Object, required: true }
  },
  emits: ["confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const { t } = useI18n();

const needsConfirmation = computed(() =>
    ['awaiting_confirmation', 'pending'].includes(props.connection.status || ''),
);
const hasRegisteredPhone = computed(() =>
    props.connection.phoneNumbers.some(
        (phone) => phone.isActive && phone.registrationStatus === 'REGISTERED',
    ),
);

const __returned__ = { props, emit, t, needsConfirmation, hasRegisteredPhone, get ExclamationIcon() { return ExclamationIcon }, get CheckCircleIcon() { return CheckCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})